import React, { FC, Fragment, useState } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MaterialMacro, MaterialMacroOption } from 'models/material-macro';
import UseMaterialMacroDialog from './use-material-macro-dialog.component';

type UseMaterialMacroButtonProps = {
    materialMacroOptions: MaterialMacroOption[];
    onAddMaterialMacro: (materialMacro: MaterialMacro) => void;
    isLoading?: boolean;
    disabled?: boolean;
    dataTest?: string;
};

// "Use macro" button plus the dialog it opens. Renders nothing while the lab has no macros,
// so every surface hides the entry point from the same place.
const UseMaterialMacroButton: FC<UseMaterialMacroButtonProps> = ({
    materialMacroOptions,
    onAddMaterialMacro,
    isLoading,
    disabled,
    dataTest,
}: UseMaterialMacroButtonProps) => {
    const { t: translate } = useTranslation(['orders']);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    if (materialMacroOptions.length === 0 && !isLoading) {
        return null;
    }

    return (
        <Fragment>
            <Button size="small" disabled={disabled} onClick={() => setIsDialogOpen(true)} data-test={dataTest}>
                {translate('orders:USE_MACRO')}
            </Button>
            <UseMaterialMacroDialog
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                materialMacroOptions={materialMacroOptions}
                onAddMaterialMacro={onAddMaterialMacro}
                isLoading={isLoading}
            />
        </Fragment>
    );
};

export default UseMaterialMacroButton;
